import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var encodeCustomizable = function encodeCustomizable(model, _ref) {
  var seats = _ref.seats,
      functionality = _ref.functionality,
      armrests = _ref.armrests,
      feet = _ref.feet,
      coatings = _ref.coatings,
      comfort = _ref.comfort;
  return [model, seats.code, functionality.code, armrests.code, feet.code, coatings.code, comfort.code].join('');
};

export default encodeCustomizable;